import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintPierre: Country = {
    identifier: "SaintPierre",
    name: "Saint Pierre and Miquelon",
    countryCode: "PM",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇵🇲",
    svgPath: "m 316.98275,314.5654 -0.245,0.176 -0.085,-0.098 0.021,-0.116 0.125,-0.279 -0.004,-0.081 -0.148,-0.542 0.025,-0.089 0.037,-0.039 0.217,0.115 0.025,0.148 -0.103,0.333 0.071,0.221 0.096,0.16 -0.032,0.091 z m 0.326,0.311 -0.059,0.039 -0.201,-0.059 0.096,-0.127 0.068,-0.037 0.091,-0.016 0.043,0.039 -0.005,0.094 -0.033,0.067 z",
}
